/**
 *
 */

import React, { useCallback, useState } from 'react'
import { EmergencyPowerSettingsModel, SettingsFormModel, useEmergencyPowerSettingsFormInitializer } from 'src/Libs/emergency-power'
import EmergencyPowerSettingsForm from 'src/Elements/SystemSettings/EmergencyPower/settings/EmergencyPowerSettingsForm'
import { FormikWithExitHandler } from 'src/Libs/form'
import { useAppRatingContext } from 'src/Libs/app-rating/hooks'

interface Props {
  model: EmergencyPowerSettingsModel
  onUpdate: (values: SettingsFormModel) => Promise<void>
  disabled?: boolean
  showWallboxSettings: boolean
}

/**
 * @constructor
 */
const EmergencyPowerSettingsData: React.VFC<Props> = ({ model, onUpdate, showWallboxSettings, disabled = false }) => {
  const { initialValues, validationSchema } = useEmergencyPowerSettingsFormInitializer(model, showWallboxSettings)
  const [formValues, setFormValues] = useState<SettingsFormModel>(initialValues)
  const { triggerAppRating } = useAppRatingContext()

  const handleUpdate = useCallback(
    async (values: SettingsFormModel) => {
      setFormValues(values)
      try {
        await onUpdate(values)
        triggerAppRating()
      } catch (error) {
        /* revert changes */
        setFormValues({ ...formValues })
      }
    },
    [onUpdate, formValues, triggerAppRating]
  )

  return (
    <FormikWithExitHandler
      formKey="emergency-power-settings-data-form"
      initialValues={formValues}
      validationSchema={validationSchema}
      onSubmit={handleUpdate}
    >
      {model && <EmergencyPowerSettingsForm showWallboxSettings={showWallboxSettings} model={model} disabled={disabled} />}
    </FormikWithExitHandler>
  )
}

export default EmergencyPowerSettingsData
